import { ApiError } from '@l2u/ui/lib/api.ts';

// Supabase's leaked-password protection (HaveIBeenPwned) rejects breached
// passwords with "...known to be weak and easy to guess...". It is the one rule
// we cannot pre-check in the browser, so we reword it into plain language rather
// than surfacing Supabase's copy. Everything else passes through untouched.
const BREACH_FRIENDLY =
  'This password appeared in an online data breach. Please choose a different one.';

export function friendlyAuthError(error: unknown): unknown {
  const message = error instanceof ApiError || error instanceof Error ? error.message : '';
  if (/weak and easy to guess/i.test(message)) {
    return new Error(BREACH_FRIENDLY);
  }
  return error;
}
